import React from "react";
var ToggleSwitch = function (props) {
    var _a, _b;
    function handleKeyPress(e) {
        if (e.keyCode !== 32)
            return;
        e.preventDefault();
        props.onChange(!props.checked);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "toggle-switch  ".concat(props.className ? props.className : props.parentClassName) + (props.small == true ? " big-switch" : "") },
            React.createElement("input", { type: "checkbox", name: props.name, className: "toggle-switch-checkbox", id: props.id, checked: props.checked, onChange: function (e) { return props.onChange(e.target.checked); }, disabled: props.disabled }),
            props.id ? (React.createElement("label", { className: "".concat(props.switchcolorClass, " ").concat(props.checked
                    ? "toggle-switch-label e-switch-active"
                    : "toggle-switch-label"), tabIndex: props.disabled ? -1 : 1, onKeyDown: function (e) { return handleKeyPress(e); }, htmlFor: props.id },
                React.createElement("span", { className: "toggle-switch-inner", "data-yes": (_a = props.ToggleInnerDataYes) !== null && _a !== void 0 ? _a : " ", "data-no": (_b = props.ToggleInnerDataNo) !== null && _b !== void 0 ? _b : " " }),
                React.createElement("span", { className: "".concat(props.switchcolorClass, " ").concat((props.checked
                        ? "toggle-switch-switch e-switch-active"
                        : "toggle-switch-switch") +
                        (props.small == true ? " big-switch" : "")) }))) : null)));
};
export default ToggleSwitch;
